import { Container, Service } from 'typedi';
import {
    AppIdentifiers,
    AreaType,
    IAppLaunchInfo,
    SourceType,
    TriggerType,
} from '@sparkware/uc-sdk-core';
import { AttributionStore } from './storage/attribution-store';

@Service()
export class AttributionResolver {
    private readonly _attributionStore: AttributionStore;

    constructor() {
        this._attributionStore = Container.get(AttributionStore);
    }

    public consumeAttributionData(
        launchInfo: IAppLaunchInfo | undefined,
    ): IAppLaunchInfo | undefined {
        if (this.hasBannerBusinessCorrelationId(launchInfo)) {
            this._attributionStore.clear();
            return launchInfo;
        }

        const consumedBusinessCorrelationId = this._attributionStore.consume();
        if (consumedBusinessCorrelationId === undefined) {
            return launchInfo;
        }

        const resolvedLaunchInfo = launchInfo ?? this.createDefaultLaunchInfo();

        return {
            ...resolvedLaunchInfo,
            businessCorrelationID: consumedBusinessCorrelationId,
        };
    }

    public attachBusinessCorrelationId(businessCorrelationID: string | undefined, data: any): void {
        if (!businessCorrelationID) {
            return;
        }

        data.BusinessCorrelationID = businessCorrelationID;
    }

    private hasBannerBusinessCorrelationId(launchInfo: IAppLaunchInfo | undefined): boolean {
        return (
            launchInfo?.channel?.area === AreaType.Banner &&
            launchInfo.businessCorrelationID !== undefined
        );
    }

    private createDefaultLaunchInfo(): IAppLaunchInfo {
        return {
            businessCorrelationID: '',
            sequentialCorrelationID: undefined,
            channel: { area: AreaType.UserArea, source: SourceType.UnifiedClient },
            appSpecificParameters: undefined,
            trigger: TriggerType.userSelection,
            containerID: undefined,
            sourceAppID: AppIdentifiers.UnifiedClient,
            sourceAppVersion: '0.0.0',
            clientVersion: undefined,
        };
    }
}
